import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Bg_Balance.png'
import _imports_1 from '@/assets/img/Bg_Works.png'
import _imports_2 from '@/assets/img/Decor_common.png'


const _withScopeId = n => (_pushScopeId("data-v-e722cc12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view profile-edit" }
const _hoisted_2 = { class: "profile__header" }
const _hoisted_3 = { class: "profile__avatar" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "button button-md button-light"
}, " Сохранить ", -1))
const _hoisted_7 = { class: "profile__cards-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Баланс",
  class: "profile__card_image"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile__card_text" }, "Баланс", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Баланс",
  class: "profile__card_image"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile__card_text" }, "Мои работы", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Мой реферальный код", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://t.me/burngram_support_bot",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "button button-md button-contrast"
}, " Связь с поддержкой ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "profile__decor",
  src: _imports_2
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "button button-md button-contrast"
}, " Использовать ", -1))

import { onBeforeMount, ref, Ref } from 'vue';
import { useRouter } from 'vue-router';
import { toast } from 'vue3-toastify';
import { ProfileService, Profile, Referral } from '@/services/ProfileService';
import BaseEditable from '@/components/shared/BaseEditable.vue';
import BaseBackLink from '@/components/shared/BaseBackLink.vue';
import BaseLoader from '@/components/shared/BaseLoader.vue';
import { AuthService } from '@/services/AuthService';
import BaseModal from '@/components/shared/BaseModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileEditView',
  setup(__props) {

const router = useRouter();

// Load profile data & referral
const profile: Ref<Profile | null> = ref(null);
const referral: Ref<Referral | null> = ref(null);
onBeforeMount(async () => {
	profile.value = await ProfileService.getProfile();
	referral.value = await ProfileService.getReferral();
});

// Referral code
const useReferralOpen: Ref<boolean> = ref(false);
const useReferralCode: Ref<string> = ref('');
async function useReferral() {
	useReferralOpen.value = false;

	const { result } = await ProfileService.useReferral(useReferralCode.value);
	if (result === 'True') {
		toast.success('Реферальный код применен');
	} else {
		toast.error('Реферальный код неверный');
	}

	useReferralCode.value = '';
}

// Save edited profile
async function onSave() {
	if (!profile.value) return;

	await ProfileService.changeProfile({
		email: profile.value?.email,
		nickname: profile.value?.nickname
	});

	toast.info('Профиль обновлен');
}
// Save uploaded avatar
async function onAvatarSave(e: Event) {
	if (
		!e.target ||
		!(e.target instanceof HTMLInputElement) ||
		!e.target.files ||
		!profile.value
	)
		return;

	// Upload
	await ProfileService.changeProfileAvatar(e.target.files[0]);

	// Update avatar
	profile.value.avatar = URL.createObjectURL(e.target.files[0]);
}

function logOut() {
	AuthService.unauthorize();
	router.push('/auth');
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (profile.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(BaseBackLink, {
              onClick: _unref(router).back,
              class: "back-link-container"
            }, null, 8, ["onClick"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: profile.value.avatar,
                alt: profile.value.nickname,
                class: "profile__avatar_image"
              }, null, 8, _hoisted_4),
              _createElementVNode("input", {
                type: "file",
                accept: ".jpg,.png,.jpeg,.bmp,.tif,.tiff|image/*",
                class: "profile__avatar_upload",
                onChange: onAvatarSave
              }, null, 32)
            ])
          ]),
          _createElementVNode("form", {
            onSubmit: _withModifiers(onSave, ["prevent"]),
            class: "profile__body form"
          }, [
            _createVNode(BaseEditable, {
              value: profile.value.nickname,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((profile.value.nickname) = $event)),
              type: "text",
              required: true,
              placeholder: "Никнейм"
            }, null, 8, ["value"]),
            _createVNode(BaseEditable, {
              value: profile.value.email,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((profile.value.email) = $event)),
              type: "email",
              required: true,
              placeholder: "Эл. почта"
            }, null, 8, ["value"]),
            _createVNode(BaseEditable, {
              value: null,
              type: "text",
              required: false,
              placeholder: "Телеграм"
            }),
            _createVNode(BaseEditable, {
              value: profile.value.id,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((profile.value.id) = $event)),
              type: "text-copy",
              required: true,
              placeholder: "ID пользователя"
            }, null, 8, ["value"]),
            _hoisted_6,
            _createElementVNode("button", {
              type: "button",
              onClick: logOut,
              class: "button button-md button-light"
            }, " Выйти "),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_RouterLink, {
                to: "/balance",
                class: "profile__card"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_RouterLink, {
                to: "/profile/works",
                class: "profile__card"
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _hoisted_12,
            _createVNode(BaseEditable, {
              value: referral.value?.words ?? 'Загрузка...',
              type: "text-share",
              required: false,
              placeholder: "Загрузка..."
            }, null, 8, ["value"]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (useReferralOpen.value = true)),
              class: "button button-md button-light"
            }, " Ввести реферальный код "),
            _hoisted_13
          ], 40, _hoisted_5)
        ], 64))
      : (_openBlock(), _createBlock(BaseLoader, { key: 1 })),
    _hoisted_14,
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      (useReferralOpen.value)
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 0,
            onSubmit: useReferral,
            onClose: _cache[5] || (_cache[5] = ($event: any) => (useReferralOpen.value = false)),
            title: "Ввести реферальный код"
          }, {
            default: _withCtx(() => [
              _createVNode(BaseEditable, {
                value: useReferralCode.value,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((useReferralCode).value = $event)),
                type: "text",
                required: true,
                placeholder: "Введите реферальный код"
              }, null, 8, ["value"]),
              _hoisted_15
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})